<template>
    <div>

        <div class="index-profile">

            <div class="main-content">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10 col-xl-10">

                            <!-- Header -->
                            <div class="header mt-md-5">
                                <div class="header-body">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <!-- Title -->
                                            <h1 class="header-title">
                                                Profile
                                            </h1>
                                        </div>
                                    </div> <!-- / .row -->
                                </div>
                            </div>

                            <profile-update></profile-update>

                            <hr>

                            <password-update></password-update>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import PasswordUpdate from './Password.vue'
    import ProfileUpdate from './Profile.vue'

    export default {
        components: {PasswordUpdate, ProfileUpdate},
        name: 'Index'
        
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/profile/Index.vue